import type { Residence } from '@repo/sdk/gen'
import { Badge, type BadgeVariant } from '@repo/ui/badge'
import { type TKey, useTranslation } from '@/lib/i18n'

type CallState = Residence['call']['state']

const LABEL: Record<CallState, TKey> = {
	draft: 'admin-residences:call_state.draft',
	published: 'admin-residences:call_state.published',
	open: 'admin-residences:call_state.open',
	closed: 'admin-residences:call_state.closed'
}

/** Draft waits on the manager, published waits for the opening date. */
const TONE: Record<CallState, BadgeVariant> = {
	draft: 'warning',
	published: 'info',
	open: 'success',
	closed: 'neutral'
}

function CallStateBadge({ state }: { state: CallState }) {
	const { t } = useTranslation()
	return <Badge variant={TONE[state]}>{t(LABEL[state])}</Badge>
}

export { CallStateBadge }
